(function () {
    angular.module('tradersyard').component('tyCountdownTimer', {
        template: `
            <div ng-if="$ctrl.enable" class="clock-container">
                <div class="clock-col">
                    <p class="clock-timer" ng-bind="$ctrl.days"></p>
                    <p class="clock-label">Days</p>
                </div>
                <div class="clock-col">
                    <p class="clock-timer" ng-bind="$ctrl.hours"></p>
                    <p class="clock-label">Hours</p>
                </div>
                <div class="clock-col">
                    <p class="clock-timer" ng-bind="$ctrl.minutes"></p>
                    <p class="clock-label">Minutes</p>
                </div>
                <div class="clock-col">
                    <p class="clock-timer" ng-bind="$ctrl.seconds"></p>
                    <p class="clock-label">Seconds</p>
                </div>
            </div>
            
            <div class="upcoming-event-item-top-streaming" ng-if="!$ctrl.enable">
                <span class="streaming-icon"></span>
            </div>
        `,
        bindings: {
            countdownTime: '<',
        },
        controller: CountdownTimerController,
    });

    CountdownTimerController.$inject = ['$interval'];

    function CountdownTimerController($interval) {
        var ctrl = this;

        ctrl.interval = undefined;
        ctrl.updatePeriod = 1000; // 1 second

        ctrl.days = '00';
        ctrl.hours = '00';
        ctrl.minutes = '00';
        ctrl.seconds = '00';

        ctrl.$onInit = function () {
            ctrl.enable = true;

            ctrl.differenceInTime = moment(ctrl.countdownTime).unix() - moment().unix();
            ctrl.duration = duration(ctrl.differenceInTime * 1000);

            if (ctrl.interval) {
                clearInterval(ctrl.interval);
                ctrl.interval = undefined;
            }

            ctrl.interval = $interval(function () {
                /**
                 * Update duration -1s
                 */
                ctrl.duration = duration(ctrl.duration.asMilliseconds() - ctrl.updatePeriod);

                if (ctrl.duration.asMilliseconds() < duration(0).asMilliseconds()) {
                    clearInterval(ctrl.interval);
                    ctrl.enable = false;
                    return;
                }

                ctrl.days = parseInt(ctrl.duration.asDays());
                ctrl.hours = ctrl.duration.hours();
                ctrl.minutes = ctrl.duration.minutes();
                ctrl.seconds = ctrl.duration.seconds();

                if (ctrl.days === 0 && ctrl.hours === 0 && ctrl.minutes === 0 && ctrl.seconds === 0) {
                    ctrl.enable = false;
                }
            }, ctrl.updatePeriod);
        };

        function duration(value) {
            return moment.duration(value);
        }
    }
})();
